import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import { ReactComponent as SoundOff } from '../../../../../../assets/icons/sound-off.svg'
import { ReactComponent as SoundOn } from '../../../../../../assets/icons/sound-on.svg'

import useStyles from './styles'

function MuteButton({ onMuteSoundToggle, isSoundMuted }) {
  const classes = useStyles()

  const muteHandler = useCallback(() => {
    onMuteSoundToggle && onMuteSoundToggle()
  }, [onMuteSoundToggle])

  return (
    <span className={classes.muteButton} onClick={muteHandler}>
      {isSoundMuted ? <SoundOff /> : <SoundOn />}
    </span>
  )
}

MuteButton.propTypes = {
  onMuteToggle: PropTypes.func,
  isInitiallyMuted: PropTypes.bool
}

export default MuteButton
